module.exports = __webpack_public_path__ + "img/banner.01343975.jpg";